import { Component, OnInit, Renderer2 } from '@angular/core';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'sso-selection',
  template: `<div [innerHTML]="htmlContent"></div>`
})
export class SsoSelectionComponent extends BaseComponent implements OnInit {

  htmlContent = '';

  constructor(private http: HttpClient, private renderer: Renderer2) {
    super();
  }

  ngOnInit(): void {
    this.http.get('assets/sso_selection.html', { responseType: 'text' }).subscribe({
      next: data => {
        this.htmlContent = data;
      },
      error: error => {
        this.htmlContent = 'No se ha definido contenido para esta página';
      }
    });
    const link = this.renderer.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'assets/sso_selection.css';
    document.head.appendChild(link);
  }

}